import {
  getRiskUnits,
  getInsuranceObjects,
  getCoverages,
  getEvents,
} from "../api/formMethods";
import Swal from "sweetalert2";
import { swalConfig } from "./constants";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(utc);
dayjs.extend(customParseFormat);

/**
 * Auto gets lists of riskUnits, insuranceObjects, coverages and events.
 * This triggers when the lists only return 1 id.
 * @param {number} operationPK
 * @param {number} apoliceProdutoId
 * @param {number} ramoId
 * @returns All auto selected id's and corresponding lists.
 */
export async function getInfoByOperationPK(
  operationPK,
  apoliceProdutoId,
  ramoId
) {
  let riskUnits = [];
  let insuranceObjects = [];
  let coverages = [];
  let events = [];

  let riskUnit = null;
  let insuranceObject = null;
  let coverage = null;

  riskUnits = await getRiskUnits(operationPK);
  if (riskUnits.length === 1) {
    riskUnit = riskUnits[0].RiskUnitId;
    insuranceObjects = await getInsuranceObjects(operationPK, riskUnit);
    if (insuranceObjects.length === 1) {
      insuranceObject = insuranceObjects[0].InsuranceObjectId;
      coverages = await getCoverages(operationPK, insuranceObject);
      if (coverages.length === 1) {
        coverage = coverages[0].GisCoverageId;
        events = await getEvents(apoliceProdutoId, coverage, ramoId);
      }
    }
  }

  return {
    riskUnit,
    riskUnits,
    insuranceObject,
    insuranceObjects,
    coverage,
    coverages,
    events,
  };
}

export function formatDate(date) {
  return dayjs(date).local().format();
}

export function formatDisplayDateTime(date) {
  if (date == null) return "";
  return dayjs(date).format(
    "DD/MM/YYYY HH:mm"
  );
}

export function formatDisplayDateOnly(date) {
  if (date == null || date == "") return "";
  return dayjs(date).format(
    "DD/MM/YYYY"
  );
}

/**
 * Shows a Swal with a generic error, then reloads the page.
 */
export function fireGenericError() {
  Swal.fire({
    ...swalConfig,
    icon: "error",
    title: "Erro de Sistema",
    text:
      "Tente novamente, se o erro permanecer, a abertura do sinistro deverá ser realizada através da central de atendimentos.",
  }).then(() => window.location.reload());
}

/**
 * Shows a specific GE error @ cobertura fora de vigencia
 */
export function fireVigenciaCoberuraErrorGE() {
  Swal.fire({
    ...swalConfig,
    icon: "error",
    title: "Erro",
    text:
      "Não é possível realizar a abertura do aviso com os dados informados. Favor entre entre em contato com a nossa central nos telefones: 3003 9309 (capitais e regiões metropolitanas) - 0800 292 4357 (demais localidades).",
  });
}

/**
 * Gets drescription from array by id
 * @param {Array} arr 
 * @param {Number} id 
 * @param {String} idDesc
 * @returns 
 */
export function getDescriptionFromArrayById(arr, id, idDesc) {
  return arr.find(x => x[idDesc] == id).Description;
}

export function handleAberturaResponse(res) {
  if (!res.Errors && !res.Warnings) {
    Swal.fire({
      ...swalConfig,
      icon: "success",
      title: "Sucesso",
      text: `Aviso nr ${res.NrAviso} criado. O acompanhamento do sinistro deverá ser realizado através da central de atendimentos.`,
    }).then(() => {
      window.location.reload();
    });
  } else {
    Swal.fire({
      ...swalConfig,
      icon: "error",
      title: "Erro",
      text: `Ocorreu um erro. A abertura do sinistro deverá ser realizada através da central de atendimentos.`,
    }).then(() => {
      window.location.reload();
    });
  }
}

export function handleAberturaResponseWithUploadDocuments(res, areaNegocio) {
  if (!res.Errors && !res.Warnings) {
    Swal.fire({
      ...swalConfig,
      icon: 'success',
      title: 'Sucesso',
      text: `Aviso nr ${res.NrAviso} criado. O acompanhamento do sinistro deverá ser realizado através da central de atendimentos.`,
    }).then(() => {
      if (window.location.host.startsWith('localhost'))
        window.location.href = `../../../LusoRoux/UploadDocumentos/MultiObjSubCategoriaUpload.aspx?ObjId=${res.ObjId}&AreaNegocioId=${areaNegocio}&noSession=true`;
      else
        window.location.href = `./LusoRoux/UploadDocumentos/MultiObjSubCategoriaUpload.aspx?ObjId=${res.ObjId}&AreaNegocioId=${areaNegocio}&noSession=true`;
    });
  } else {
    Swal.fire({
      ...swalConfig,
      icon: 'error',
      title: 'Erro',
      text: `Ocorreu um erro. A abertura do sinistro deverá ser realizada através da central de atendimentos.`,
    }).then(() => {
      window.location.reload();
    });
  }
}